module.exports = __webpack_public_path__ + "img/hexagonalwarning.daa5209a.svg";